import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-account-eve2-consent-success',
  templateUrl: './account-eve2-consent-success.component.html',
  styleUrls: ['./account-eve2-consent-success.component.scss'],
  standalone: false
})
export class AccountEve2ConsentSuccessComponent {
  @Output() closeModal: EventEmitter<void> = new EventEmitter();
}
